namespace RioERP.Web.Enums {
    export enum PaymentMode {
        Cash = 1,
        Cheque = 2,
        Online = 3,
        CreditCard = 4,
        DebitCard = 5,
        UPI = 6,
        NetBanking = 7,
        CashOnDelivery = 8,
        CashOrOnline = 9
    }
    Serenity.Decorators.registerEnumType(PaymentMode, 'RioERP.Web.Enums.PaymentMode');
}
